import { render, staticRenderFns } from "./CollectionAction.vue?vue&type=template&id=f3eec566&scoped=true"
import script from "./CollectionAction.vue?vue&type=script&lang=js"
export * from "./CollectionAction.vue?vue&type=script&lang=js"
import style0 from "./CollectionAction.vue?vue&type=style&index=0&id=f3eec566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eec566",
  null
  
)

export default component.exports